import request from '@/config/axios'

/** O2O 师傅 — 阶段 3 对接 /admin-api/o2o/provider/* */
export const O2oProviderApi = {
  getPage: async (params: any) => {
    return await request.get({ url: '/o2o/provider/page', params })
  },
  get: async (id: number) => {
    return await request.get({ url: '/o2o/provider/get?id=' + id })
  },
  updateStatus: async (data: { id: number; status: string }) => {
    return await request.put({ url: '/o2o/provider/update-status', data })
  }
}

export const O2oProviderAuditApi = {
  getPage: async (params: any) => {
    return await request.get({ url: '/o2o/provider/audit/page', params })
  },
  pass: async (data: any) => {
    return await request.put({ url: '/o2o/provider/audit/pass', data })
  },
  reject: async (data: any) => {
    return await request.put({ url: '/o2o/provider/audit/reject', data })
  }
}
